export const ZhChtOutOfOfficeStrings = {
  UPDATE_SUCCESS_MSG: "不在辦公室 時間表已更新",
  DELETE_SUCCESS_MSG: "不在辦公室 時間表已移除",

  OUT_OF_OFFICE_UNTIL: "不在辦公室直到 "
}
